module.exports = __webpack_public_path__ + "static/img/wx-gzh.dfc449a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/wx-gzh.png
// module id = eJX7
// module chunks = 16